import React from 'react';

import { StaticImageData } from 'next/image';
import { ArrowButtonProps } from 'Elements/Button/Arrow';

import {
    Container,
    StyledLandscapeImage,
    StyledPortraitImage,
    Wrapper,
    ImageWrapper,
    Content,
    StyledArrowButton,
    Heading
} from './CourseListing.styled';

export interface Props {
    heading: string;
    headingType?: 'h2' | 'h3';
    text: string | React.ReactNode;
    image: {
        desktop: { alt?: string; src: StaticImageData | string };
        mobile: { alt?: string; src: StaticImageData | string };
    };
    link?: ArrowButtonProps;
}

const CourseListing: React.FC<Props> = ({ heading, headingType = 'h2', text, link, image }) => {
    return (
        <Wrapper>
            <Container>
                <Content>
                    <Heading as={headingType}>{heading}</Heading>
                    {typeof text === 'string' ? <p>{text}</p> : text}
                    {link && <StyledArrowButton {...link} variant="primary" />}
                </Content>
                <ImageWrapper>
                    <StyledLandscapeImage
                        src={image.desktop.src}
                        alt={image.desktop.alt ? image.desktop.alt : ''}
                        fill
                    />
                    <StyledPortraitImage
                        src={image.mobile.src}
                        alt={image.mobile.alt ? image.mobile.alt : ''}
                        fill
                    />
                </ImageWrapper>
            </Container>
        </Wrapper>
    );
};

export default CourseListing;
